import { useAppState } from 'Context/AppContext/AppContext'
import { Button } from '@resiliatech/birdsong'
import { IntakeFlowStep } from '../../constants'
import { sendStepTransitionEvent } from '../../utils'
import { StyledTextField } from './OtherFocusAreas.styled'
import { ActionContainer, Container } from '../../IntakeFlow.styled'

type Props = {
  onNextStep: (nextStep: IntakeFlowStep) => void
  onBackStep: () => void
  onSetOtherFocusAreas: (challenge: string) => void
  otherFocusAreas: string
}

export const OtherFocusAreas = ({
  onNextStep,
  onBackStep,
  onSetOtherFocusAreas,
  otherFocusAreas,
}: Props) => {
  const { nonprofitOrgConfig, userConfig } = useAppState()

  const handleNext = () => {
    sendStepTransitionEvent({
      currentStep: IntakeFlowStep.OTHER_FOCUS_AREAS,
      nextStep: IntakeFlowStep.LOADING_IMPACT_PLAN,
      userId: userConfig.id,
      nonprofitOrgId: nonprofitOrgConfig.orgId,
      funderOrgId: nonprofitOrgConfig.funderOrgId,
      userEmail: userConfig.email,
      userPrimaryFunction: undefined,
      userJourneyLength: 0,
      userRole: undefined,
    })
    onNextStep(IntakeFlowStep.LOADING_IMPACT_PLAN)
  }

  return (
    <Container>
      <StyledTextField
        fullWidth
        multiline
        minRows={4}
        value={otherFocusAreas}
        placeholder='My organization struggles with raising funds to support our community initiatives. We often find it challenging to connect with potential donors and showcase the impact of their contributions. Despite our best efforts, securing financial backing remains a hurdle that we continuously work to overcome.'
        onChange={(e) => onSetOtherFocusAreas(e.target.value)}
      />
      <ActionContainer>
        <Button variant='text' onClick={onBackStep}>
          Back
        </Button>
        <Button variant='primary' onClick={handleNext} label='Next' />
      </ActionContainer>
    </Container>
  )
}
